import { defineComponent } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import InboxView from './views/InboxView.vue'
import { installStaleBuildGuard } from './lib/staleBuild'
import { installNavProgress } from './lib/pagePrefetch'
import { installDashVariant } from './lib/dashVariant'

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { path: '/', name: 'inbox', component: InboxView },
    { path: '/c/:id', name: 'conversation', component: InboxView, props: true },
    // Comments under FB/IG posts and ads (design Comments5)
    { path: '/comments', name: 'comments', component: () => import('./views/CommentsView.vue') },
    // Sales-from-chat dashboard (design Dash5)
    { path: '/dash', name: 'dash', component: () => import('./views/DashView.vue') },
    // แดชบอร์ด แบบ B — used next to /dash for a while to see which is more useful (owner 27 ก.ย. 69) · docs/dashboard-b.md
    { path: '/dash-b', name: 'dash-b', component: () => import('./views/DashBView.vue') },
    // โฆษณา — the owner's ads command center (spec docs/superpowers/specs/2026-10-20-ads-command-center-design.md);
    // owner only: App.vue sends anyone else back to the chats (lib/adsView pageAllowed)
    { path: '/ads', name: 'ads', component: () => import('./views/AdsView.vue'), meta: { ownerOnly: true } },
    // หน้าโพสต์ — ตั้งเวลาโพสต์ Facebook + Instagram (spec docs/superpowers/specs/2026-10-22-social-post-scheduler-design.md);
    // owner only like /ads (lib/adsView OWNER_ONLY_PAGES · the API answers 403 too)
    { path: '/posts', name: 'posts', component: () => import('./views/PostsView.vue'), meta: { ownerOnly: true } },
    // หลังบ้านพาร์ทเนอร์ — อนุมัติพาร์ทเนอร์ ตั้งค่าคอม (affiliate plan 2026-10-26 P2 Track B); owner + head, never the reviewer:
    // App.vue sends anyone else back to the chats (lib/affiliate affiliatePageAllowed · the API answers 403 too), and the
    // page goes to "/" when the server switch is off (GET /api/v1/affiliate/status 404)
    { path: '/affiliate', name: 'affiliate', component: () => import('./views/AffiliateView.vue'), meta: { managerOnly: true } },
    // Team settings (design Config5); one component per section in components/config/
    { path: '/config/:section?', name: 'config', component: () => import('./views/ConfigView.vue'), props: true },
    // คลังความรู้ AI: shop facts, approved answers, answer rules, test box, history (api/app/ai/kb.py)
    { path: '/knowledge/:section?', name: 'knowledge', component: () => import('./views/KnowledgeView.vue'), props: true },
    // สุขภาพระบบ at /status (NOT /health: DO ingress sends /health* to the API) · owner + head · api/app/health, docs/health.md
    { path: '/status', name: 'health', component: () => import('./views/HealthView.vue') },
    // Meta App Review reviewer sign-in (api/app/reviewer.py): App.vue shows ReviewerSignIn here when signed out and
    // goes to the inbox once signed in — the route itself renders nothing
    { path: '/login', name: 'login', component: defineComponent({ name: 'LoginRoute', render: () => null }) },
    { path: '/:rest(.*)*', redirect: '/' },
  ],
})

// old tab after a deploy: a missing page chunk or a newer build → real page load instead of a silent no-op
installStaleBuildGuard(router)
// thin top bar while a page change waits (pages are prefetched after sign-in: App.vue)
installNavProgress(router)
// a plain /dash opens แบบ B for an owner/manager who chose it last (lib/dashVariant.ts)
installDashVariant(router)
